export default "__VITE_ASSET__CXYHI2X9__"